import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slice/userSlice";
import reportSlice from "./slice/reportSlice";

const store = configureStore({
  reducer: {
    userReducer: userSlice,
    reportReducer: reportSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
